import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../helpers/constants";
import { notify, notifyAPIMessages } from "../../helpers/commonFunction";
import { commonMessage } from "../../helpers/messages";
import { Axios, authHeaders } from "../../helpers/axios";

export const reqToUserLogin = createAsyncThunk(
  apiEndpoints.login,
  async ({ data, onSuccess, onFailure }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(apiEndpoints.login, data);
      onSuccess?.(response);
      return response;
    } catch (error) {
      onFailure?.(error);
      return rejectWithValue(error);
    }
  }
);

export const reqToUserLogout = createAsyncThunk(
  apiEndpoints.logout,
  async ({ data, onSuccess, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.logout,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      return rejectWithValue(error);
    }
  }
);

export const reqToMedRepRegistration = createAsyncThunk(
  apiEndpoints.psrRegistration,
  async ({ data, onSuccess, dispatch }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.psrRegistration,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        dispatch?.(reqToForceUserLogout());
      }
      return rejectWithValue(error);
    }
  }
);

export const reqToSendOTP = createAsyncThunk(
  apiEndpoints.sendOTP,
  async ({ data, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.sendOTP,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reqToVerifySendOTP = createAsyncThunk(
  apiEndpoints.verifyOTP,
  async ({ data, onSuccess }, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        apiEndpoints.verifyOTP,
        data,
        authHeaders()
      );
      onSuccess?.(response);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialUser = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : null;

const initialState = {
  loader: false,
  user: initialUser,
  error: "",
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    reqToForceUserLogout: (state) => {
      state.user = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    // USER LOGIN
    builder
      .addCase(reqToUserLogin.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToUserLogin.fulfilled, (state, action) => {
        state.loader = false;
        if (action.payload.status === 200) {
          state.user = { ...action.payload.data };
          notify(commonMessage.login, "success");
          const authToken = action.payload.headers["authorization"];
          localStorage.setItem("token", JSON.stringify(authToken));
          localStorage.setItem(
            "user",
            JSON.stringify({ ...action.payload.data })
          );
        }
      })
      .addCase(reqToUserLogin.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });

    // USER LOGOUT
    builder
      .addCase(reqToUserLogout.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToUserLogout.fulfilled, (state, action) => {
        state.loader = false;
        if (action.payload.status === 200) {
          state.user = null;
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          notify(commonMessage.logout, "success");
        }
      })
      .addCase(reqToUserLogout.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });

    // MED REP REGISTRATION
    builder
      .addCase(reqToMedRepRegistration.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToMedRepRegistration.fulfilled, (state, action) => {
        state.loader = false;
      })
      .addCase(reqToMedRepRegistration.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });

    // SEND OTP
    builder
      .addCase(reqToSendOTP.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToSendOTP.fulfilled, (state, action) => {
        state.loader = false;
        console.log("action", action.payload);
        notifyAPIMessages(action.payload);
      })
      .addCase(reqToSendOTP.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });

    // VERIFY OTP
    builder
      .addCase(reqToVerifySendOTP.pending, (state) => {
        state.loader = true;
      })
      .addCase(reqToVerifySendOTP.fulfilled, (state, action) => {
        state.loader = false;
        if (action.payload.status === 200) {
          state.user = { ...action.payload.data };
          notify(commonMessage.login, "success");
          const authToken = action.payload.headers["authorization"];
          localStorage.setItem("token", JSON.stringify(authToken));
          localStorage.setItem(
            "user",
            JSON.stringify({ ...action.payload.data })
          );
        }
      })
      .addCase(reqToVerifySendOTP.rejected, (state, action) => {
        state.loader = false;
        notifyAPIMessages(action.payload);
      });
  },
});
export const { reqToForceUserLogout } = userSlice.actions;
export default userSlice.reducer;
